import { initNativeShell } from "./native/platform";
import React from "react";
import ReactDOM from "react-dom/client";

import AppRouter from "./approuter";
import axios from "axios";

// Sessions last an hour; the server sends a renewed token in this header once less than half
// of it is left. Only the dashboard's own axios instance used to pick it up, so everyone was
// logged out an hour after login however active they were.
axios.interceptors.response.use(res => {
  const renewed = res.headers?.["x-refresh-token"];
  if (renewed && localStorage.getItem("token")) localStorage.setItem("token", renewed);
  return res;
});

import "./commons/PanelAssets/css/bootstrap.min.css";
import "./i18n.jsx";

import "react-image-lightbox/style.css";
import "react-datepicker/dist/react-datepicker.css";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./i18n.jsx";

if (
  window.location.pathname.includes("service-provider") ||
  window.location.pathname.includes("admin") ||
  window.location.pathname.includes("employees")
) {
  require("./commons/PanelAssets/plugins/fontawesome/css/fontawesome.min.css");
  require("./commons/PanelAssets/plugins/fontawesome/css/all.min.css");
  require("./commons/PanelAssets/css/font-awesome.min.css");

  require("./commons/PanelAssets/css/custom.css");
  require("./commons/PanelAssets/scss/main.scss");
  require("./commons/PanelAssets/css/feathericon.min.css");
  require("./commons/PanelAssets/js/feather.min.js");
  require("./commons/PanelAssets/css/bootstrap.min.css");
  require("./commons/PanelAssets/plugins/fontawesome/js/fontawesome.min.js");
} else {
  require("./normalUsers/assets/css/all.css");
  require("./normalUsers/assets/css/all.min.css");
  require("./normalUsers/assets/css/fontawesome.min.css");
  require("./normalUsers/assets/css/custom.css");
}

import "./index.css";
import "./rtl.css";
/* Design system: tokens → component skin → mobile layer (order matters) */
import "./design-system/tokens.css";
import "./design-system/legacy.css";
import "./design-system/components.css";
import "./design-system/calendar.css";
import "./design-system/responsive.css";
import { SocketProvider } from "./context/SocketContext";
import { UserContextProvider } from "./context/UserContext.jsx";
import { registerServiceWorker } from "./offline/registerServiceWorker";
import { startOfflineSync } from "./offline";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <UserContextProvider>
    <SocketProvider>
      <React.Suspense fallback={null}>
        <AppRouter />
      </React.Suspense>
    </SocketProvider>
  </UserContextProvider>
);
initNativeShell();
// Offline: app shell (web, production only) and the outbox replay of the field modules
registerServiceWorker();
startOfflineSync();
